<mat-table [dataSource]="data" class="mat-elevation-z8">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  
    <!-- Position Column -->
    <ng-container matColumnDef="message">
      <mat-header-cell *matHeaderCellDef>Message</mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.message}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="change">
      <mat-header-cell *matHeaderCellDef>Change</mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.change}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="timestamp">
        <mat-header-cell *matHeaderCellDef>Timestamp</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element._createdAt | date }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="user">
        <mat-header-cell *matHeaderCellDef>User</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element._createdBy}} </mat-cell>
      </ng-container>
  
  
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>
  
